import './register.css';
import '../Footer/Footer'
import React, { useState, useEffect } from "react";
import { emailVerify, otpVerify, userregistration } from "../../../services/CommonService";
import { Link, useLocation } from "react-router-dom";
import { Modal, Button, Form, Row, Col, Container } from 'react-bootstrap';
import Swal from 'sweetalert2';

function Registration({ show, onHide }) {

    const [termsAccepted, setTermsAccepted] = useState(false);
    // const [showModal, setShowModal] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showAddForm, setShowAddForm] = useState(false);
    const [validated, setValidated] = useState(false);
    const [emailSent, setEmailSent] = useState(false);
    const [showEmailModal, setShowEmailModal] = useState(true);
    const [isSendingEmail, setIsSendingEmail] = useState(false);
    const [showRegistrationModal, setShowRegistrationModal] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showcnfpsw, setshowcnfpsw] = useState(false);
    const [showTermsModal, setShowTermsModal] = useState(false);
    const [modalCheckboxChecked, setModalCheckboxChecked] = useState(false);
    const [otpTimer, setOtpTimer] = useState(120); // 2 minutes in seconds
    const [showResend, setShowResend] = useState(false);
    const [otpTrigger, setOtpTrigger] = useState(0);



    const initialFormState = {
        email: ""
    };

    const [formData, setFormData] = useState({
        email: ""
    });

    const passwordsMatch = formData.password === formData.password_confirmation;

    useEffect(() => {
        let timerInterval;

        if (emailSent) {
            setOtpTimer(120);
            setShowResend(false);

            timerInterval = setInterval(() => {
                setOtpTimer(prev => {
                    if (prev <= 1) {
                        clearInterval(timerInterval);
                        setShowResend(true);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }

        return () => clearInterval(timerInterval);
    }, [otpTrigger]); // <-- Change from [emailSent] to [otpTrigger]




    const handleOtpVerification = async () => {
        const optData = {
            email: formData.email,
            otp: formData.otp
        }
        setShowRegistrationModal(true); // Open registration modal
    };

    // Close Modal
    const handleClose = () => {
        setShowAddForm(false);
        setFormData(initialFormState);
        setShowModal(false);
        setEmailSent(false);
    };

    // form change control
    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "name") {
            const alphabetOnly = value.replace(/[^a-zA-Z\s]/g, ""); // Only letters and spaces
            setFormData(prev => ({ ...prev, [name]: alphabetOnly }));
        } else if (name === "phone") {
            const digitsOnly = value.replace(/\D/g, ""); // Remove non-digit characters
            if (digitsOnly.length <= 10) {
                setFormData(prev => ({ ...prev, [name]: digitsOnly }));
            }
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        const buttonName = e.nativeEvent.submitter.name;
        if (form.checkValidity() === false) {
            e.stopPropagation();
            setValidated(true);
            return;
        }

        if (!formData.email || formData.email.trim() === "") {
            Swal.fire({
                icon: 'warning',
                title: 'Oops!',
                text: 'Looks like you forgot to enter your email address.'
            });
            return;
        }
        if (buttonName == "sendEmail") {
            const dat = { email: formData.email };
            try {
                const response = await emailVerify(dat);
                setEmailSent(true);          // OTP section shows
                setOtpTrigger(prev => prev + 1);  // Triggers timer restart
                Swal.fire({
                    title: "Success!",
                    text: response.data.message,
                    icon: "success",
                    confirmButtonText: "OK",
                });
            } catch (err) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error!',
                    text: (err?.response?.data?.message || err.message)
                });
                return
            }
        }
        else if (buttonName == "otpverify") {
            if (!formData.otp) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Oops!',
                    text: 'Looks like you forgot to enter your otp.'
                });
                return;
            }
            try {
                const optData = {
                    email: formData.email,
                    otp: formData.otp
                }
                const response = await otpVerify(optData);
                if (response.data.message == 'OTP verified. You may now complete registration.') {
                    onHide();
                    setEmailSent(false);
                    setShowRegistrationModal(true); // Open registration modal
                    resetForm();
                }
            } catch (error) {
                Swal.fire({
                    title: "Error!",
                    text: (error?.response?.data?.message || error.message),
                    icon: "error",
                    confirmButtonText: "OK",
                });
            }
        }
        else if (buttonName == "register") {
            const fieldLabels = {
                name: 'Name',
                email: 'Email Address',
                password: 'Password',
                phone: 'Phone Number',
                password_confirmation: 'Confirm Password',
                organization: 'Organisation'
            }
            for (const key of Object.keys(fieldLabels)) {
                if (!formData[key] || formData[key].trim() === "") {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Oops!',
                        text: `Looks like you forgot to enter your ${fieldLabels[key] || key}.`,
                    });
                    return;
                }
            }
            const strongPasswordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;
            if (!strongPasswordRegex.test(formData.password)) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Weak Password',
                    text: 'Password must be at least 8 characters long and include uppercase, lowercase, number, and special character.'
                });
                return;
            }
            const optData = {
                email: formData.email,
                name: formData.name,
                organization: formData.organization,
                password: formData.password,
                password_confirmation: formData.password_confirmation,
                phone: formData.phone
            }
            try {
                const response = await userregistration(optData); // replace with your actual API call
                if (response.data.message == 'User registered successfully.') {
                    Swal.fire({
                        title: "Success!",
                        text: response.data.message,
                        icon: "success",
                        confirmButtonText: "OK",
                    });
                    setShowRegistrationModal(false); // Open registration modal
                    // setShowModal(false);

                }
            } catch (err) {
                Swal.fire({
                    title: "Error!",
                    text: (err?.response?.data?.message || err.message),
                    icon: "error",
                    confirmButtonText: "OK",
                });
            }
        }

    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            // ...prev
            ...formData,
            [name]: value,
        }));
    };

    const resetForm = () => {
        setFormData({
            email: '',
            password: '',
            otp: ''
        });
        setShowPassword(false);
    };

    const isFormValid = () => {
        const { name, phone, email, organization, password, password_confirmation } = formData;
        return (
            name?.trim() !== '' &&
            phone?.trim() !== '' &&
            email?.trim() !== '' &&
            organization?.trim() !== '' &&
            password?.trim() !== '' &&
            password_confirmation?.trim() !== '' &&
            password === password_confirmation
        );
    }
    return (
        <>
            <Modal show={show} onHide={onHide} centered>
                <Modal.Header
                    closeButton onClick={handleClose}
                    style={{ backgroundColor: "#FFA500", color: "#000", fontWeight: "bold" }}
                >
                    <Modal.Title>Email Verification</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{}}>
                    <Container>
                        <Form onSubmit={handleSubmit} noValidate validated={validated}>
                            <Row className="mb-3">
                                <Col md={12}>
                                    <Form.Group controlId="formEmail">
                                        <Form.Label style={{
                                            fontSize: 'medium',
                                            fontWeight: '600'
                                        }}>Email<span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="email"
                                            name="email"
                                            placeholder="Enter email"
                                            value={formData.email}
                                            // onChange={handleChange}
                                            onChange={handleInputChange}
                                            style={{
                                                border: '1px solid #ed9003',
                                                color: '#000',
                                                padding: '5px',
                                                fontSize: 'smaller'
                                            }}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please enter valid email address.
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                            </Row>

                            {emailSent && (
                                <Row className="mb-3">
                                    <Col md={12}>
                                        <Form.Group controlId="formOtp">
                                            <Form.Label style={{
                                                fontSize: 'medium',
                                                fontWeight: '600'
                                            }}>Enter OTP <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="number"
                                                name="otp"
                                                placeholder="Enter OTP"
                                                value={formData.otp}
                                                // onChange={handleChange}
                                                onChange={handleInputChange}
                                                style={{
                                                    border: '1px solid #ed9003',
                                                    color: '#000',
                                                    padding: '5px',
                                                    fontSize: 'smaller'
                                                }}
                                            />
                                            {otpTimer > 0 ? (
                                                <div className="text-muted mt-1" style={{ fontSize: 'small' }}>
                                                    Time remaining: {String(Math.floor(otpTimer / 60)).padStart(2, '0')}:
                                                    {String(otpTimer % 60).padStart(2, '0')}
                                                </div>
                                            ) : (
                                                <div className="mt-2">
                                                    <Button variant="link" type="submit" name="sendEmail">
                                                        Resend OTP
                                                    </Button>
                                                    {/* <Button style={{ backgroundColor: '#28186f', marginRight: '5px' }} type="submit" name="sendEmail">
                                                        Send
                                                    </Button> */}
                                                </div>
                                            )}
                                        </Form.Group>
                                    </Col>
                                </Row>
                            )}

                            <div className="text-end mt-3">
                                {emailSent ? (
                                    <Button style={{ backgroundColor: '#28186f', marginRight: '5px' }} type='submit' name="otpverify">
                                        Verify OTP
                                    </Button>
                                ) : (
                                    <Button style={{ backgroundColor: '#28186f', marginRight: '5px' }} type="submit" name="sendEmail">
                                        Send
                                    </Button>
                                )}
                                {/* <Button variant="secondary" onClick={handleClose}>
                                    Cancel
                                </Button> */}
                            </div>
                        </Form>

                    </Container>
                </Modal.Body>
            </Modal>
            <Modal show={showRegistrationModal} onHide={() => setShowRegistrationModal(false)} centered>
                <Modal.Header closeButton style={{ backgroundColor: "#FFA500" }}>
                    <Modal.Title> User Register</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{}}>
                    <Container>
                        <Form onSubmit={handleSubmit}>
                            <Row className="mb-3">
                                <Col md={6}>
                                    <Form.Group controlId="formName">
                                        <Form.Label style={{
                                            fontSize: 'medium',
                                            fontWeight: '600'
                                        }}>Name<span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="name"
                                            placeholder="Enter name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            style={{
                                                border: '1px solid #ed9003',
                                                color: '#000',
                                                padding: '5px',
                                                fontSize: 'smaller'
                                            }}
                                        // className="shadow-sm"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group controlId="formPhone">
                                        <Form.Label style={{
                                            fontSize: 'medium',
                                            fontWeight: '600'
                                        }}>Phone<span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="tel"
                                            name="phone"
                                            placeholder="Enter phone"
                                            value={formData.phone}
                                            onChange={handleChange}
                                            style={{
                                                border: '1px solid #ed9003',
                                                color: '#000',
                                                padding: '5px',
                                                fontSize: 'smaller'
                                            }}
                                        // className="shadow-sm"
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col md={6}>
                                    <Form.Group controlId="formEmail">
                                        <Form.Label style={{
                                            fontSize: 'medium',
                                            fontWeight: '600'
                                        }}>Email<span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="email"
                                            name="email"
                                            placeholder="Enter email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            style={{
                                                border: '1px solid #ed9003',
                                                color: '#000',
                                                padding: '5px',
                                                fontSize: 'smaller'
                                            }}
                                        // className="shadow-sm"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group controlId="formOrganization">
                                        <Form.Label style={{
                                            fontSize: 'medium',
                                            fontWeight: '600'
                                        }}>Organization<span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="organization"
                                            placeholder="Enter organization"
                                            value={formData.organization}
                                            onChange={handleChange}
                                            style={{
                                                border: '1px solid #ed9003',
                                                color: '#000',
                                                padding: '5px',
                                                fontSize: 'smaller'
                                            }}
                                        // className="shadow-sm"
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <Form.Group controlId="formPassword" style={{ position: 'relative' }}>
                                        <Form.Label style={{
                                            fontSize: 'medium',
                                            fontWeight: '600'
                                        }}>
                                            Password <span className="text-danger">*</span>
                                        </Form.Label>

                                        <Form.Control
                                            type={showPassword ? 'text' : 'password'}
                                            name="password"
                                            placeholder="Enter password"
                                            value={formData.password}
                                            onChange={handleChange}
                                            style={{
                                                border: '1px solid #ed9003',
                                                color: '#000',
                                                paddingRight: '35px',
                                                fontSize: 'smaller',
                                                padding: '6px'
                                            }}
                                        />

                                        <i
                                            className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`}
                                            onClick={() => setShowPassword(!showPassword)}
                                            style={{
                                                position: 'absolute',
                                                right: '10px',
                                                top: '38px',
                                                cursor: 'pointer',
                                                fontSize: '1rem',
                                                color: '#555'
                                            }}
                                        ></i>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group controlId="formConfirmPassword" style={{ position: 'relative' }}>
                                        <Form.Label style={{
                                            fontSize: 'medium',
                                            fontWeight: '600'
                                        }}> Confirm Password<span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type={showcnfpsw ? 'text' : 'password'}
                                            name="password_confirmation"
                                            placeholder="Enter confirm password"
                                            value={formData.password_confirmation}
                                            onChange={handleChange}
                                            style={{
                                                border: '1px solid #ed9003',
                                                color: '#000',
                                                padding: '5px',
                                                fontSize: 'smaller'
                                            }}
                                        // className="shadow-sm"
                                        />
                                        <i
                                            className={`bi ${showcnfpsw ? 'bi-eye-slash' : 'bi-eye'}`}
                                            onClick={() => setshowcnfpsw(!showcnfpsw)}
                                            style={{
                                                position: 'absolute',
                                                right: '10px',
                                                top: '38px',
                                                cursor: 'pointer',
                                                fontSize: '1rem',
                                                color: '#555'
                                            }}
                                        ></i>
                                        {formData.password_confirmation && formData.password !== formData.password_confirmation && (
                                            <div className="text-danger" style={{ fontSize: 'smaller' }}>
                                                Passwords do not match
                                            </div>
                                        )}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <div style={{ marginBottom: '20px' }}>
                                    <label
                                        style={{ fontSize: '14px', cursor: 'pointer', color: '#007bff', textDecoration: 'underline' }}
                                        onClick={() => setShowTermsModal(true)}
                                    >
                                        Click to read and acknowledge the terms & Conditions.
                                    </label>
                                </div>

                            </Row>
                            {showTermsModal && (
                                <div
                                    style={{
                                        position: 'fixed',
                                        top: 0, left: 0, right: 0, bottom: 0,
                                        backgroundColor: 'rgba(0,0,0,0.5)',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        zIndex: 9999
                                    }}
                                >
                                    <div
                                        style={{
                                            backgroundColor: 'white',
                                            padding: '20px',
                                            borderRadius: '8px',
                                            width: '90%',
                                            maxWidth: '1000px',
                                            textAlign: 'center',
                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)'
                                        }}
                                    >
                                        <h2>Terms & Conditions</h2>
                                        <div style={{ maxHeight: '300px', overflowY: 'auto', textAlign: 'left', marginTop: '15px' }}>
                                            <p>As part of our commitment to responsible data use, we ask for your consent to:</p>
                                            <ul style={{ paddingLeft: '20px' }}>
                                                <li>Be registered on our platform</li>
                                                <li>Access and download resources under the applicable usage guidelines</li>
                                                <li>Acknowledge that all downloadable reports are for appropriate use only, and are subject to our licensing and terms</li>
                                                <li>Agree that your personal information will not be shared or used outside our organization under any circumstances</li>

                                            </ul>
                                            <p>
                                                We value your privacy and take data protection seriously. Your information will be stored securely and used solely for the purposes of communication and access related to this platform.
                                                If you have any questions or concerns, feel free to contact us at [admin@acwadam.org].
                                            </p>
                                        </div>

                                        {/* Checkbox inside Modal */}
                                        <div style={{ marginTop: '15px', textAlign: 'left' }}>
                                            <label style={{ fontSize: '14px' }}>
                                                <input
                                                    type="checkbox"
                                                    checked={modalCheckboxChecked}
                                                    onChange={(e) => setModalCheckboxChecked(e.target.checked)}
                                                    style={{ marginRight: '8px' }}
                                                />
                                                I have read and agree to the Terms & Conditions.
                                            </label>
                                        </div>

                                        {/* Modal Buttons */}
                                        <div style={{ marginTop: '20px' }}>
                                            <button
                                                onClick={() => {
                                                    setTermsAccepted(true);
                                                    setShowTermsModal(false);
                                                    setModalCheckboxChecked(false); // Reset for next time
                                                }}
                                                disabled={!modalCheckboxChecked}
                                                style={{
                                                    padding: '10px 20px',
                                                    backgroundColor: modalCheckboxChecked ? '#007bff' : '#ccc',
                                                    color: 'white',
                                                    border: 'none',
                                                    borderRadius: '6px',
                                                    cursor: modalCheckboxChecked ? 'pointer' : 'not-allowed',
                                                    marginRight: '10px'
                                                }}
                                            >
                                                Accept
                                            </button>
                                            <button
                                                onClick={() => {
                                                    setShowTermsModal(false);
                                                    setModalCheckboxChecked(false); // Optional reset
                                                }}
                                                style={{
                                                    padding: '10px 20px',
                                                    backgroundColor: '#ccc',
                                                    border: 'none',
                                                    borderRadius: '6px',
                                                    cursor: 'pointer'
                                                }}
                                            >
                                                Close
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="text-end mt-3">
                                <button
                                    type="submit"
                                    className="login-button"
                                    name="register"
                                    disabled={!termsAccepted} // ✅ Disable if terms not accepted
                                    style={{
                                        width: '100%',
                                        padding: '12px',
                                        backgroundColor: termsAccepted ? '#007bff' : '#ccc', // Dim color when disabled
                                        color: 'white',
                                        fontWeight: '600',
                                        border: 'none',
                                        borderRadius: '6px',
                                        cursor: termsAccepted ? 'pointer' : 'not-allowed',
                                        transition: 'background-color 0.3s ease',
                                    }}
                                    onMouseOver={(e) => {
                                        if (termsAccepted) e.currentTarget.style.backgroundColor = '#0056b3';
                                    }}
                                    onMouseOut={(e) => {
                                        if (termsAccepted) e.currentTarget.style.backgroundColor = '#007bff';
                                    }}
                                >
                                    Register
                                </button>
                            </div>
                        </Form>
                    </Container>
                </Modal.Body>
            </Modal>
        </>
    );


}

export default Registration;